import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { AppConfigApi } from '@app/features/app-content/models/app-config.model';
import { FetchAppConfigRequest } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select, Store } from '@ngxs/store';

import { Observable, Subscription } from 'rxjs';

@Injectable()
export class ActiveGuard {
  constructor(private readonly store: Store) {}

  private readonly subscription: Subscription = new Subscription();

  @Select(AppConfigurationState.currentAppConfig)
  currentAppConfig$: Observable<AppConfigApi>;

  canActivate(routeSnap: ActivatedRouteSnapshot): Observable<boolean> {
    return new Observable<boolean>(subject => {
      const appId = routeSnap.params['appId'];
      if (appId) {
        this.store.dispatch(new FetchAppConfigRequest(appId));
      }
      this.subscription.add(
        this.currentAppConfig$.subscribe(config => {
          if (config?.status) {
            if (
              config?.status === 'active' ||
              config?.status === 'terminee' ||
              config?.status === 'publication'
            ) {
              subject.next(true);
            }
            subject.next(false);
          }
        }),
      );
    });
  }
}
